"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    resolveChatContentHeight: ()=>resolveChatContentHeight,
    resolveChatContentStyle: ()=>resolveChatContentStyle
});
const EXPANDABLE_INPUT_INIT_OFFSET = 85;
function resolveChatContentHeight(args) {
    const { isDialogStylesEmpty, expandableTextHeight } = args;
    const heightOffset = EXPANDABLE_INPUT_INIT_OFFSET + expandableTextHeight;
    if (!isDialogStylesEmpty) return `calc(100% - ${heightOffset}px)`;
    return 'calc(100% - 120px)';
}
function resolveChatContentStyle(args) {
    const { isDialogStylesEmpty, dialogStyles, standaloneStyles } = args;
    return isDialogStylesEmpty ? standaloneStyles : dialogStyles;
}
exports.resolveChatContentHeight = __webpack_exports__.resolveChatContentHeight;
exports.resolveChatContentStyle = __webpack_exports__.resolveChatContentStyle;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "resolveChatContentHeight",
    "resolveChatContentStyle"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
